import { createRouter, createWebHistory } from 'vue-router'
import Home from '../pages/Home.vue'
import CompanyProfile from '../pages/CompanyProfile.vue'
import AboutUs from '../pages/AboutUs.vue'
import Products from '../pages/Products.vue'
import Download from '../pages/Download.vue'
import Contact from '../pages/Contact.vue'
import News from '../pages/News.vue'
import NewsDetail from '../pages/NewsDetail.vue'
const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/company',
    name: 'Company',
    component: CompanyProfile,
  },
  {
    path: '/about',
    name: 'About',
    component: AboutUs,
  },
  {
    path: '/products',
    name: 'Products',
    component: Products,
  },
  {
    path: '/download',
    name: 'Download',
    component: Download,
  },
  {
    path: '/news',
    name: 'News',
    component: News,
  },
  {
      path: '/news/:id', // 动态 id 匹配
      name: 'NewsDetail',
      component: NewsDetail
    },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact,
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  },
})

export default router
